import { ACCESS_GROUPS, hasAccessGroup } from "../../access-control/models/access-groups.models";
import { useAuthContext } from "../../auth/state/AuthContext";
import { useAdminAgentSessionScope } from "../hooks/useAdminAgentSessionScope";
import { getAdminAgentBrowserTokenScope } from "../utils/admin-agent.utils";
import AdminAgentWorkspace from "./AdminAgentWorkspace";
import { Provider } from "jotai";

// Keep the assistant inside the admin shell and require the actual Admin group.
// Feature grants alone do not expose this early admin capability.
const AdminAgentDock = () => {
  const user = useAuthContext().state.user;
  const token = user?.accessToken;
  const groups = token?.groups;
  const currentScope = useAdminAgentSessionScope();
  let renderedScope: string | undefined;

  try {
    renderedScope = user?.accessTokenRaw ? getAdminAgentBrowserTokenScope(user.accessTokenRaw) : undefined;
  } catch {
    renderedScope = undefined;
  }

  if (!hasAccessGroup(groups, ACCESS_GROUPS.Admin) || !currentScope || currentScope !== renderedScope) {
    return null;
  }

  // A new caller or permission scope gets fresh drafts, request IDs and selection before any history is rendered.
  const scope = JSON.stringify([
    token?.sub,
    [...(groups ?? [])].sort(),
    [...(user?.accessControl?.grantedFeatures ?? [])].sort(),
    token?.firstname,
    token?.lastname,
  ]);

  return (
    <Provider key={scope}>
      <AdminAgentWorkspace />
    </Provider>
  );
};

export default AdminAgentDock;
